import {
  Language,
  OrganizationRole,
  ProjectRole,
  ServicePermissionName,
  ServicePermissionLabels,
} from '@consigli/types';

export interface InviteFormData {
  recipients: string[];
  language: Language | null;
  organizationRole: OrganizationRole | null;
  organizationId: string | null;
  canCreateProjects: boolean;
  projects: ProjectAccess[];
}

export interface ProjectAccess {
  id: number;
  name: string;
  role: ProjectRole;
  permissions: ServicePermissionName[];
}

export interface FormErrors {
  recipients?: string;
  language?: string;
  organizationRole?: string;
  organizationId?: string;
  canCreateProjects?: string;
  projects?: string;
}

export const defaultInviteFormData: InviteFormData = {
  recipients: [],
  language: null,
  organizationRole: null,
  organizationId: null,
  canCreateProjects: false,
  projects: [],
};

// Service permission options for project access
export const servicePermissionOptions = Object.values(ServicePermissionName).map((permission) => ({
  label: ServicePermissionLabels[permission],
  value: permission,
}));
